

<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
  {{$.row[$.adata.keyName] | date :$.row[$.adata.format] }}
</ng-container>